import { i18n } from "../../i18n";

// Shared by the Device/Status alarm card and the map popup so both describe an
// alarm the same way: a translated type-specific message, or a generic
// scope/sequence/value fallback when the backend alarm type has no translation.
export const getAlarmMessage = (alarm, t) => {
  const typeExists = i18n.exists(`alarms.types.${alarm.type}`);

  const title = (() => {
    if (typeExists && i18n.exists(`alarms.types.${alarm.type}.title`)) {
      return t(`alarms.types.${alarm.type}.title`);
    }

    const prefix = alarm.sequence
      ? `${t(`alarms.scopes.${alarm.scope}`)} ${alarm.sequence}`
      : t("alarms.title");

    return `${prefix}: ${alarm.value}`;
  })();

  const description =
    typeExists && i18n.exists(`alarms.types.${alarm.type}.description`)
      ? t(`alarms.types.${alarm.type}.description`)
      : alarm.value || "";

  return { title, description };
};
